import React, { Component } from 'react'
import BookingServices from '../../services/axiosServices/apiServices/BookingServices';
import moment from "moment";
import { Navigate } from 'react-router-dom';
import { checkParameters } from '../../utils/Encryption';
import SwalServices from '../../services/swalServices/SwalServices';
import { lightFormat } from 'date-fns';
import ButtonLoader from '../../components/common/buttonLoader/ButtonLoader';

export default class l̥NewBookingCancellationDetail extends Component {
    constructor(props) {
        super(props);
        this.bookingServices = new BookingServices();
        this.swalServices = new SwalServices
        this.state = {
            bookingCancellationDetails: {
                cancellationId: 0,
                className: "",
                classDate: "",
                eventFormStartDate: "",
                eventFormEndDate: "",
                availableSessions: 0,
                reason: "",
                bookingReferenceNo: "",
                bookingStatus: "",
                attendeeName: "",
                contactNo: "",
                bookingDate: "",
                paymentVia: "",
                promoCode: "",
                subTotalPrice: "",
                discountPrice: "",
                totalPrice: "",
                location: "",
                eventStartTime: "",
                eventEndTime: "",
                paymentStatus: "",
                requestType:"",
                rescheduleDate:"",
                rescheduleStartTime:"",
                rescheduleEndTime:"",
            },
            route: "",
            isApproveLoading: false,
            isRejectLoading: false,
        };
    }

    getBookingCancellationDetailsById = (id) => {
                  this.bookingServices.getBookingCancellationDetailsById(id).then((response) => {

            if (response.statusCode === 200 && response.responseItem != null) {
response.responseItem.responseContent.bookingDate = moment(response.responseItem.responseContent.bookingDate).format("DD MMM YYYY")
                response.responseItem.responseContent.classDate = moment(response.responseItem.responseContent.classDate).format("DD MMM YYYY")
                var details = response.responseItem.responseContent;
                                this.setState({ bookingCancellationDetails: details });
            } else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        })
    }

    componentDidMount() {
             let params = new URLSearchParams(window.location.search);
        let CancellationId = params.get("");
        if (CancellationId && (CancellationId = checkParameters(CancellationId, "Number"))) {
            if (CancellationId != null && CancellationId > 0) {  
                this.getBookingCancellationDetailsById(CancellationId);
            }
        }

    }

    approveBookingRequestForCancellation = () => {
        let req = {};
        req.cancellationId = this.state.bookingCancellationDetails.cancellationId ? this.state.bookingCancellationDetails.cancellationId : null;
        let cancellationId = this.state.cancellationId;
        this.setState({ isApproveLoading: true })
        this.bookingServices.approveBookingRequestForCancellation(req).then((response) => {

            if (response.statusCode === 200 && response.responseItem != null) {
                this.swalServices.Success("Request has been approved")
            }
            else {
                this.swalServices.Error(response.message);
            }
                        this.setState({ isApproveLoading: false })
            this.setState({ route: "/booking/BookingCancellation" });
        })
    }

    rejectBookingRequestForCancellation = () => {
        let req = {};
        req.cancellationId = this.state.bookingCancellationDetails.cancellationId ? this.state.bookingCancellationDetails.cancellationId : null;
        req.bookingReferenceNo = this.state.bookingCancellationDetails.bookingReferenceNo ? this.state.bookingCancellationDetails.bookingReferenceNo : "";
        req.eventName = this.state.bookingCancellationDetails.eventName ? this.state.bookingCancellationDetails.eventName : "";
        req.bookingStatus = this.state.bookingCancellationDetails.bookingStatus ? this.state.bookingCancellationDetails.bookingStatus : "";
        req.eventTypeName = this.state.bookingCancellationDetails.eventTypeName ? this.state.bookingCancellationDetails.eventTypeName : "";
        req.attendeeName = this.state.bookingCancellationDetails.attendeeName ? this.state.bookingCancellationDetails.attendeeName : "";
        req.attendeeEmail = this.state.bookingCancellationDetails.attendeeEmail ? this.state.bookingCancellationDetails.attendeeEmail : "";
        req.requestDate = this.state.bookingCancellationDetails.requestDate ? this.state.bookingCancellationDetails.requestDate : null;


        let cancellationId = this.state.cancellationId;
        this.setState({ isRejectLoading: true })
        this.bookingServices.rejectBookingRequestForCancellation(req).then((response) => {

            if (response.statusCode === 200 && response.responseItem != null) {
                this.swalServices.Success("Request has been rejected")

            }
            else {
                this.swalServices.Error(response.message);

            }
            this.setState({ isRejectLoading: false })
            this.setState({ route: "/booking/BookingCancellation" });
        })
    }


    render() {
        if (this.state.route != null && this.state.route !== "") {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div>
                <div className="main-body-section">
                    <div className="bg-white">
                        <div className=" heading-part px-7 py-4 border-b">
                            <h4 className="small-title font-bold theme-color">
                            {this.state.bookingCancellationDetails.requestType === "Reschedule"
                                    ? "Booking Reschedule Details"
                                    : "Booking Cancellation Details"}
                            </h4>
                        </div>

                        <div className='mb-2 overflow-x-auto  px-7 py-4'>
                            <table className="partner-tbl w-full mx-auto my-5 fixed_header border-2">
                                <thead >
                                    <tr className="text-base font-bold flex">
                                        <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                            <div className="font-bold tble-th-txt text-left">Event Name</div>
                                        </th>
                                        <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                            <div className="font-bold tble-th-txt text-center ">Event Date</div>
                                        </th>
                                        <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                            <div className="font-bold tble-th-txt text-center">Time</div>
                                        </th>
                                        <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                            <div className="font-bold tble-th-txt text-center">Session</div>
                                        </th>
                                        <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                            <div className="font-bold tble-th-txt text-center">Location</div>
                                        </th>

                                    </tr>
                                </thead>
                                <tbody className="scrollit text-sm custom-tbody ">

                                    <tr className='custom-tbl-td flex'>
                                        <td className=" px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                            {this.state.bookingCancellationDetails.className}
                                        </td>
                                        <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                            <div className="dollar-sign-icon inline-block">
                                                {this.state.bookingCancellationDetails.classDate}

                                            </div>
                                        </td>
                                        <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                            <div className="dollar-sign-icon inline-block">
                                                {this.state.bookingCancellationDetails.eventStartTime} -
                                                {this.state.bookingCancellationDetails.eventEndTime}
                                            </div>
                                        </td>
                                        <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                            {this.state.bookingCancellationDetails.availableSessions}
                                        </td>
                                        <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                            {this.state.bookingCancellationDetails.location ?
                                                this.state.bookingCancellationDetails.location
                                                : "N.A"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div><div className='px-7 py-4'>
                            <div className='border w-full'>
                                <div className=" heading-part px-4 py-4">
                                <h4 className="small-title font-bold theme-color">
                                {this.state.bookingCancellationDetails.requestType === "Reschedule"
                                ? "Reschedule Details"
                                : "Cancellation Details"}
                                </h4>
                                </div>
                                <div className="grid grid-cols-12 gap-6">
                                    <div className="xl:col-span-12 lg:col-span-12 col-span-12">
                                        <div className="flex items-center ">
                                            <h2 className="text-xl theme-color w-[50%] ml-4 py-2 ">
                                                Reason:
                                            </h2>
                                            <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                                {this.state.bookingCancellationDetails.reason}
                                            </h2>
                                        </div>
                                        <div className="flex items-center ">
                                            <h2 className="text-xl theme-color w-[50%] ml-4 py-2 ">
                                                {this.state.bookingCancellationDetails.requestType === "Reschedule"
                                                ? "Reschedule Date:"
                                                : "Cancellation Date:"}
                                            </h2>
                                            <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                          
                                                                {moment(this.state.bookingCancellationDetails.rescheduleDate).format("DD MMM YYYY")}
                                                                {" ("}
                                                                {this.state.bookingCancellationDetails.requestType === "Reschedule"
                                                                    ? `${this.state.bookingCancellationDetails.rescheduleStartTime} - ${this.state.bookingCancellationDetails.rescheduleEndTime}`
                                                                    : `${this.state.bookingCancellationDetails.eventStartTime} - ${this.state.bookingCancellationDetails.eventEndTime}`
                                                                }
                                                                {")"}
                                            </h2>
                                            </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" heading-part px-7 py-4">
                            <h4 className="small-title font-bold theme-color">
                                Booking Details
                            </h4>
                        </div>
                        <div className=' px-7 py-4 '>
                            <div className="grid grid-cols-12 gap-6 w-full">
                                <div className="xl:col-span-6 lg:col-span-6 col-span-12  border">
                                    <div className="flex items-center ">
                                        <h2 className="text-xl theme-color ml-4 py-2  w-[50%]">
                                            Booking Ref No:
                                        </h2>

                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                            {this.state.bookingCancellationDetails.bookingReferenceNo}
                                        </h2>
                                    </div>
                                    <div className="flex items-center">
                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                            Status:
                                        </h2>

                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">

                                            {this.state.bookingCancellationDetails.bookingStatus}
                                        </h2>
                                    </div>
                                    <div className="flex items-center">
                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                            Attendee:
                                        </h2>

                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">

                                            {this.state.bookingCancellationDetails.attendeeName}
                                        </h2>
                                    </div>
                                    <div className="flex items-center">
                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                            Contact No:
                                        </h2>

                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">

                                            {this.state.bookingCancellationDetails.contactNo}
                                        </h2>
                                    </div>

                                </div>

                                <div className="xl:col-span-6 lg:col-span-6 col-span-12  border">
                                    <div className="flex items-center">
                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                            Booking Date:
                                        </h2>

                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">

                                            {this.state.bookingCancellationDetails.bookingDate}
                                        </h2>
                                    </div>
                                    <div className="flex items-center">
                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                            Payment Type:
                                        </h2>

                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">

                                            {this.state.bookingCancellationDetails.paymentVia}
                                        </h2>
                                    </div>
                                    <div className="flex items-center">
                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                            Payment Status:
                                        </h2>

                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">

                                            {this.state.bookingCancellationDetails.paymentStatus}
                                        </h2>
                                    </div>
                                    <div className="flex items-center">
                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                            Price:
                                        </h2>

                                        <h2 className="text-xl theme-color ml-4 py-2 w-[50%]">
                                            {`$${parseFloat(this.state.bookingCancellationDetails.totalPrice).toFixed(2)}`}
                                        </h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-6">
                        <div className="2xl:col-span-12 lg:col-span-12 col-span-12">
                            <div className="flex flex-wrap justify-between space-x-10 mt-12">
                                <div>
                                    <button
                                        className="w-32 px-7 py-2 btn-sm btn-gray text-lg text-white"
                                        onClick={() => {
                                            this.setState({
                                                route: "/booking/BookingCancellation",
                                            });
                                        }}>
                                        Back
                                    </button>
                                </div>
                                <div className="flex gap-4 items-center">
                                    {this.state.isRejectLoading === true ?
                                        (
                                            <ButtonLoader className="w-32 h-10 px-7 py-2 buttonload  btn btn-theme-dark text-xl text-white " />
                                        ) : (
                                            <button
                                                className="w-32 px-7 h-10 py-2 btn-sm btn-theme-dark text-lg text-white"
                                                onClick={() => this.rejectBookingRequestForCancellation()}
                                            >
                                                Reject
                                            </button>

                                        )
                                    }
                                    {this.state.isApproveLoading === true ?
                                        (
                                            <ButtonLoader className="w-32 h-10 px-7 py-2 buttonload btn btn-red text-xl text-white " />
                                        ) : (
                                            <button
                                                className="w-32 h-10 px-7 py-2  btn-sm btn-red text-lg text-white"
                                                onClick={() => this.approveBookingRequestForCancellation()}
                                            >
                                                Approve

                                            </button>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
